<template>
  <!--
    Unlocked fork: the "billable" seat badge (and its link to Baserow's
    subscriptions docs) was removed — there are no paid seats to bill for.
  -->
  <div v-if="roleUID" class="highest-role-field">
    {{ roleName }}
  </div>
</template>

<script>
export default {
  name: 'HighestPaidRoleField',
  props: {
    row: {
      required: true,
      type: Object,
    },
    column: {
      required: true,
      type: Object,
    },
  },
  computed: {
    roleUID() {
      return this.row[this.column.key]
    },
    roleName() {
      return this.role ? this.role.getName() : ''
    },
    role() {
      return Object.values(this.$registry.getAll('roles')).find(
        (role) => role.getUid() === this.roleUID
      )
    },
  },
}
</script>
